module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "Learn"
  }, [(_vm.items) ? _c('learn-component', {
    attrs: {
      "items": _vm.items
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4624f204"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Learn.vue
// module id = 825
// module chunks = 1